import UserService from '@/services/UserService'

export const namespaced = true

export const state = {
  isFetchingStaticData: false,
  channels: [],
  countries: [],
  availableLists: []
}

export const mutations = {
  SET_IS_FETCHING_STATIC_DATA (state, val) {
    state.isFetchingStaticData = val
  },
  SET_CHANNELS (state, channels) {
    state.channels = channels
  },
  SET_COUNTRIES (state, countries) {
    state.countries = countries
  },
  SET_AVAILABLE_LISTS (state, lists) {
    state.availableLists = lists
  }
}

export const actions = {
  fetchStaticData ({ commit }) {
    // Hämta data som behövs i client och som existerar i statiska tabeller, och därför normalt aldrig behöver synkas eller hämtas om förutom vid tvingande uppdateringar.
    // Exempel: Countries, Channels, LodgingTypes, Beds, Tax, Amenities, DashboardCards, PaymentMethods(?), Roles
    commit('SET_IS_FETCHING_STATIC_DATA', true)
    return UserService.getStaticData()
      .then(({ data }) => {
        commit('SET_CHANNELS', data.data.channels)
        commit('SET_COUNTRIES', data.data.countries)
        commit('SET_AVAILABLE_LISTS', data.data.available_lists)
        commit('position/SET_LODGING_TYPES', data.data.lodging_types, { root: true })
        commit('stats/SET_DASHBOARD_CARDS', data.data.dashboard_cards, { root: true })
      })
      .finally(() => {
        commit('SET_IS_FETCHING_STATIC_DATA', false)
      })
  },

  // Enrich
  enrichCountries ({ state }) {
    return new Promise((resolve, reject) => {
      window.enrich.enrichCountry(state.countries)
      resolve(true)
    })
  }
}

export const getters = {
  defaultCountry: function (state) {
    if (state.countries.length === 0) {
      return null
    }
    return state.countries.find(c => c.id === 752) // 752 = Sverige
  },
  bookVisitChannels: function (state) {
    return state.channels.filter(c => c.is_bookvisit_channel)
  }
}
